import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';

import { Observable, throwError } from 'rxjs';
import { User } from '../_models';
import { BaseResponse, ListResponse } from '../_common';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class UserService {
    constructor(private http: HttpClient) { }

    getManager(id: any): Observable<User> {
      return this.http.get(`${environment.apiUrl}/manager/find/${id}`)
      .pipe(
        map((data: BaseResponse) => {
          return new User().deserialize(data.data);
        }),
        catchError(error => throwError(error.message || error))
      );
    }

    getAll(filter: any): Observable<ListResponse>  {
      return this.http.post(`${environment.apiUrl}/manager/list`, JSON.stringify(filter))
      .pipe(
        map((data: ListResponse) => {
          var res = data.status == 1 && data.data.list == undefined ? null : new ListResponse().deserialize(data, User)
          return res;
        }),
        catchError(error => throwError(error.message || error))
      );
    }

    addManager(data): Observable<User> {
      return this.http.post(`${environment.apiUrl}/manager/save`, JSON.stringify(data))
      .pipe(
        map((data: BaseResponse) => {
          return this.passBackMsg(data);
        }),
        catchError(error => throwError(error.message || error))
      );
    }

    updateManager(data): Observable<User> {
      return this.http.post(`${environment.apiUrl}/manager/update/${data.id}`, JSON.stringify(data))
      .pipe(
        map((data: BaseResponse) => {
          return this.passBackMsg(data);
        }),
        catchError(error => throwError(error.message || error))
      );
    }

    changeManagerPassword(passwords): Observable<User> {
      return this.http.post(`${environment.apiUrl}/manager/change-pwd`, JSON.stringify(passwords))
      .pipe(
        map((data: BaseResponse) => {
          return this.passBackMsg(data);
        }),
        catchError(error => throwError(error.message || error))
      );
    }

    resetManagerPassword(id: any): Observable<any> {
      return this.http.put<any>(`${environment.apiUrl}/manager/reset-pwd/${id}`, {})
      .pipe(
        map((data: any) => {
          return data;
        }),
        catchError(error => throwError(error.message || error))
      );
    }

    deleteManager(id: any): Observable<BaseResponse> {
      return this.http.delete(`${environment.apiUrl}/manager/delete/${id}`)
      .pipe(
        map((data: BaseResponse) => {
          return data;
        }),
        catchError(error => throwError(error.message || error))
      );
    }

    getAllClients(): Observable<BaseResponse> {
      return this.http.get(`${environment.apiUrl}/manager/clients`)
      .pipe(
        map((data: BaseResponse) => {
          return data;
        }),
        catchError(error => throwError(error.message || error))
      );
    }

    private passBackMsg(data){ //only call this when passing back single model
      return data.status == 1 ? new User().deserialize(data.data) : new User().deserialize(data);
    }

}
